export const STORAGE_RBD = 'rbd'
export const STORAGE_GPFS = 'gpfs'
export const STORAGE_NFS = 'nfs'
export const STORAGE_CLVM = 'clvm'
export const STORAGE_SLVM = 'slvm'

// kvm 共享存储
export const KVM_SHARE_STORAGES = [
  STORAGE_RBD,
  STORAGE_GPFS,
  STORAGE_NFS,
  STORAGE_CLVM,
  STORAGE_SLVM,
]
